// @flow
import axios from 'axios';
import { getAuthToken } from '../context/auth';
import ApiResponse from '../model/ApiResponse';

const baseUrl = process.env.REACT_APP_SERVER_BASE_URL || '';

export const urlOf = (endpoint: string): string => {
  return `${baseUrl}${endpoint}`;
};

const api = axios.create({
  baseURL: baseUrl,
  responseType: 'json',
  timeout: 1000 * 60 * 20,
});

const headers = (isMultipart: ?boolean) => {
  const authToken = getAuthToken();
  return {
    'X-Api-Client': process.env.REACT_APP_API_CLIENT_TOKEN,
    'Authorization': authToken ? `Bearer ${authToken}` : null,
    'Content-Type': isMultipart ? 'multipart/form-data' : 'application/json',
    'X-CLIENT-SOURCE': 'CREATOR_WEB',
    'ngrok-skip-browser-warning': true
  };
};

export const doGet = async (url: string): Promise<ApiResponse> => {
  try {
    const response = await api.get(url, {
      headers: headers(),
    });
    return ApiResponse.parse(response);
  } catch (e) {
    return ApiResponse.parseError(e);
  }
};

export const doGetBinary = async (url: string): Promise<ApiResponse> => {
  try {
    const response = await api.get(url, {
      responseType: 'arraybuffer',
      headers: headers(),
    });
    return ApiResponse.parseBinary(response);
  } catch (e) {
    return ApiResponse.parseError(e);
  }
};

export const doPost = async (url: string, data: any): Promise<ApiResponse> => {
  try {
    const response = await api.post(url, data, {
      headers: headers(),
    });
    return ApiResponse.parse(response);
  } catch (e) {
    return ApiResponse.parseError(e);
  }
};

export const doPostMultipart = async (url: string, data: any, files: any): Promise<ApiResponse> => {
  const formData = new FormData();
  for (let key of Object.keys(data)) {
    formData.append(key, data[ key ]);
  }

  for (let key of Object.keys(files)) {
    formData.append(key, files[ key ]);
  }

  try {
    const response = await api.post(url, formData, {
      headers: headers(true),
    });
    return ApiResponse.parse(response);
  } catch (e) {
    return ApiResponse.parseError(e);
  }
};

export const doDelete = async (url: string): Promise<ApiResponse> => {
  try {
    const response = await api.delete(url, {
      headers: headers(),
    });
    return ApiResponse.parse(response);
  } catch (e) {
    return ApiResponse.parseError(e);
  }
};
